var text_field_default = {
  "root": "w7m-M",
  "text": "hP4YR",
  "input": "w98Cp",
  "small": "GuF1l",
  "medium": "pD7ia",
  "large": "Iii5v",
  "webview": "i3yHQ",
  "endAdornment": "BdfTw",
  "shown": "MWHWZ",
  "value": "gl5VF",
  "spinner": "bHNhc",
  "spin": "o6IWD"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
